/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateSASTokenRequest
 */
export interface GenerateSASTokenRequest {
    /**
     * Original filename
     * @type {string}
     * @memberof GenerateSASTokenRequest
     */
    filename: string;
    /**
     * MIME type of the file
     * @type {string}
     * @memberof GenerateSASTokenRequest
     */
    mimeType: string;
}

/**
 * Check if a given object implements the GenerateSASTokenRequest interface.
 */
export function instanceOfGenerateSASTokenRequest(value: object): value is GenerateSASTokenRequest {
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    return true;
}

export function GenerateSASTokenRequestFromJSON(json: any): GenerateSASTokenRequest {
    return GenerateSASTokenRequestFromJSONTyped(json, false);
}

export function GenerateSASTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateSASTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'mimeType': json['mimeType'],
    };
}

  export function GenerateSASTokenRequestToJSON(json: any): GenerateSASTokenRequest {
      return GenerateSASTokenRequestToJSONTyped(json, false);
  }

  export function GenerateSASTokenRequestToJSONTyped(value?: GenerateSASTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
        'mimeType': value['mimeType'],
    };
}

